import React, {useEffect} from 'react';
import BannerAsistenciaEnLinea from '../OnlineAssistant/BannerAsistenciaEnLinea/index';
import AsistenciaEnLineaDescripcion from '../OnlineAssistant/AsistenciaEnLinea/index';


export default function OnlineAssistant(props){

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    return(<>
    <BannerAsistenciaEnLinea/>
    <div style={{height: '20px'}}></div>
    <AsistenciaEnLineaDescripcion/>
    <div style={{height: '20px'}}></div>
    </>)
}